import { createContext } from "react";
import { TEmblaSliderContextValue } from "./types";

const EmblaSliderContext = createContext<TEmblaSliderContextValue | null>(null);
export default EmblaSliderContext;
